// extracted by mini-css-extract-plugin
export default {"container":"v4-z","heading":"w4-z","links":"x4-z","copy":"y4-z","subCopy":"z4-z","linksLeft":"A4-z","linksCenter":"B4-z","linksRight":"C4-z","link":"D4-z","onlyLink":"E4-z"};